import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {TSMap} from "typescript-map";
import Utils from "platform/util/Utils";
import {OnLoggedOut, SetAuthStatusType} from "core/redux/auth/AuthReduxActions";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {LessonsReduxState} from "core/redux/lessons/LessonsReduxState";
import LessonsEngine from "core/engine/LessonsEngine";
import {
    ConfirmRequestEnableLearningCenterType,
    FetchUIConfigurationType,
    OptInLessonType,
    RequestEnableEbookType,
    RequestExtendTutorialsType,
    SetLDAcademyConfiguration,
    SetLDAcademyConfigurationPayload,
    SetLesson,
    SetLessonPayload,
    SetLessons,
    SetLessonsPayload,
    SetAcademyVideo,
    SetAcademyVideoPayload, SetAcademyVideoType
} from "core/redux/lessons/LessonsReduxActions";
import {Lesson} from "protocol/config/GetUIConfigurationResponse";
import {SetLDPlatformPropsType, ShowAppCuesFlowType} from "core/redux/app/AppReduxActions";
import {LDAcademyVideo, LDAppCuesWalkThrough} from "core/props/LDPlatformProps";

const initialState = (): LessonsReduxState => {
    return {
        appCuesWalkThroughGroups: [],
        appCuesWalkThrough: new TSMap<number, LDAppCuesWalkThrough[]>(),
        academyVideoGroups: [],
        academyVideos: new TSMap<number, LDAcademyVideo[]>(),
        supportZendesk: {},
        categories: [],
        lessons: new TSMap<number, Lesson[]>(),
        lesson: null,
        EbookUrl: null,
        academyVideo: {}
    };
};

export default class LessonsReducer extends Reducer<LessonsReduxState> {

    private static _instance: LessonsReducer;

    public static instance(): LessonsReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const lessonsEngine: LessonsEngine = Platform.engine(ServiceType.Lessons);
        this._middlewareActions.set(SetLDPlatformPropsType, lessonsEngine.onSetLDPlatformProps);
        this._middlewareActions.set(SetAuthStatusType, lessonsEngine.doSetAuthStatus);
        this._middlewareActions.set(FetchUIConfigurationType, lessonsEngine.doFetchUIConfiguration);
        this._middlewareActions.set(OptInLessonType, lessonsEngine.doOptInLesson);
        this._middlewareActions.set(RequestEnableEbookType, lessonsEngine.doRequestEnableEbook);
        this._middlewareActions.set(ConfirmRequestEnableLearningCenterType, lessonsEngine.doConfirmRequestEnableLearningCenter);
        this._middlewareActions.set(RequestExtendTutorialsType, lessonsEngine.doRequestExtendTutorials);
        this._middlewareActions.set(SetAcademyVideoType, lessonsEngine.doSetAcademyVideo);
        this._middlewareActions.set(ShowAppCuesFlowType, lessonsEngine.doShowAppCuesFlow);
    }

    public get name(): string {
        return "lessons";
    }

    protected setup(builder: ReducerBuilder<LessonsReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: LessonsReduxState, action: Action<any>) => {
                return {
                    ...initialState(),
                    appCuesWalkThroughGroups: state.appCuesWalkThroughGroups,
                    appCuesWalkThrough: state.appCuesWalkThrough,
                    academyVideoGroups: state.academyVideoGroups,
                    academyVideos: state.academyVideos,
                    supportZendesk: state.supportZendesk
                };
            })
            .handle(SetLessons, (state: LessonsReduxState, {payload}: Action<SetLessonsPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.categories = payload.categories;
                newState.lessons = payload.lessons;
                newState.EbookUrl = payload.EbookUrl;
                newState.LearningCenterExpiration = payload.LearningCenterExpiration;
                return newState;
            })
            .handle(SetLDAcademyConfiguration, (state: LessonsReduxState, {payload}: Action<SetLDAcademyConfigurationPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.appCuesWalkThroughGroups = payload.walkThroughGroups;
                newState.appCuesWalkThrough = payload.walkThrough;
                newState.academyVideoGroups = payload.academyVideoGroups;
                newState.academyVideos = payload.academyVideos;
                newState.supportZendesk = payload.supportZendesk;
                return newState;
            })
            .handle(SetLesson, (state: LessonsReduxState, {payload}: Action<SetLessonPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.lesson = payload.lesson;
                return newState;
            })
            .handle(SetAcademyVideo, (state: LessonsReduxState, {payload}: Action<SetAcademyVideoPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.academyVideo = payload.video;
                return newState;
            });
    }
}
